import classNames from "classnames";
import React, { CSSProperties } from "react";
import SadFaceIcon from "../../../assets/sad_face.paths.svg";
import styles from "./sadFace.css";

interface Props {
  className?: string;
  style?: CSSProperties;
}

export const SadFace = ({ className, style }: Props) => {
  return (
    <div
      className={classNames(styles.container, className)}
      style={style}
      dangerouslySetInnerHTML={{ __html: SadFaceIcon }}
    />
  );
};
